import { Extension, isMarkActive } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    clearFormatting: {
      clearFormatting: () => ReturnType;
    };
  }
}

type ClearFormattingOptions = {
  markTypes: string[];
};

export const ClearFormatting = Extension.create<ClearFormattingOptions>({
  name: "clearFormatting",

  addOptions() {
    return {
      markTypes: ["bold", "italic", "underline", "strike"],
    };
  },

  addCommands() {
    return {
      clearFormatting:
        () =>
        ({ tr, dispatch, commands, state }) => {
          const { selection } = tr;
          const { empty } = selection;

          if (!dispatch) {
            return true;
          }

          if (empty) {
            this.options.markTypes.forEach((typeName) => {
              const markType = state.schema.marks[typeName];

              if (isMarkActive(state, markType)) {
                tr.removeStoredMark(markType);
              }
            });

            return true;
          }

          return commands.unsetAllMarks();
        },
    };
  },
});
